export default {
      id: "cone-usage",
      viewBox: "0 0 52 49",
      url: __webpack_public_path__ + "sprite.svg#cone",
      toString: function () {
        return this.url;
      }
    }